import { render } from "./TheCard.vue?vue&type=template&id=9f1e1c5a"
import script from "./TheCard.vue?vue&type=script&lang=js"
export * from "./TheCard.vue?vue&type=script&lang=js"

import exportComponent from "F:\\Softwaresul\\Projetos Node\\LWP\\Nil Key\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__